import { apolloClient, cachePersistor } from 'providers/graphql';
import offlineServices from 'utils/OfflineServices';
export const resetCache = async () => {
  await cachePersistor.purge();
  // await apolloClient.resetStore();
  await apolloClient.cache.reset();
  await offlineServices.prepareCache();
};
